var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bookmark" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.deleted
          ? _c("div", { staticClass: "bookmarks__undo" }, [
              _c("p", { staticClass: "bookmarks__undo-text" }, [
                _vm._v("\n        Lesezeichen wurde gelöscht.\n      "),
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "bookmarks__undo-text bookmarks__undo-text--full",
                },
                [
                  _vm._v("\n        Lesezeichen "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.bookmark.title) +
                        " - " +
                        _vm._s(_vm.bookmark.subtitle)
                    ),
                  ]),
                  _vm._v(" wurde gelöscht.\n      "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "bookmarks__undo-button",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.restore()
                    },
                  },
                },
                [_vm._v("\n        Wiederherstellen\n      ")]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.deleted
        ? [
            _c(
              "a",
              { staticClass: "bookmark_link", attrs: { href: _vm.url } },
              [
                _c("h1", { staticClass: "bookmark__title" }, [
                  _vm._v(_vm._s(_vm.bookmark.title)),
                ]),
                _vm._v(" "),
                _c("h2", { staticClass: "bookmark__subtitle" }, [
                  _vm._v(_vm._s(_vm.bookmark.subtitle)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bookmark__meta" }, [
                  _c("div", { staticClass: "bookmark__meta-group" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "bookmark__meta-item bookmark__meta-item--magazine",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.magazine.screen_name) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "bookmark__meta-item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.bookmark.issue) +
                          "/" +
                          _vm._s(_vm.bookmark.year) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.bookmark.pdf_page
                      ? _c("span", { staticClass: "bookmark__meta-item" }, [
                          _vm._v("\n            (PDF-Version)\n          "),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bookmark__meta-group" }, [
                    _c("span", { staticClass: "bookmark__meta-item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.bookmark.category) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.bookmark.keywords
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "bookmark__meta-item bookmark__meta-item--keywords",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.bookmark.keywords) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing",
                  },
                ],
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "focus",
                      rawName: "v-focus",
                      value: _vm.focus,
                      expression: "focus",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.comment,
                      expression: "comment",
                    },
                  ],
                  staticClass: "bookmark__comment",
                  attrs: { name: "comment", type: "text" },
                  domProps: { value: _vm.comment },
                  on: {
                    blur: _vm.save,
                    keyup: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        )
                          return null
                        return _vm.cancel.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.save.apply(null, arguments)
                      },
                      _vm.detectChanges,
                    ],
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.comment = $event.target.value
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editing,
                    expression: "!editing",
                  },
                ],
                staticClass: "bookmark__comment-container",
              },
              [
                _vm.comment
                  ? _c(
                      "p",
                      {
                        staticClass: "bookmark__comment",
                        attrs: {
                          "aria-label": "Ihre Notiz:",
                          role: "textbox",
                          "aria-readonly": "false",
                        },
                        on: { click: _vm.edit },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(_vm.comment) + "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.comment
                  ? _c(
                      "p",
                      {
                        staticClass:
                          "bookmark__comment bookmark__comment--empty",
                        attrs: {
                          role: "textbox",
                          "aria-readonly": "false",
                          "aria-placeholder": "Notiz hinzufügen...",
                          "aria-label": "Ihre Notiz:",
                        },
                        on: { click: _vm.edit },
                      },
                      [_vm._v("\n            Notiz hinzufügen...\n        ")]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.removing,
                    expression: "!removing",
                  },
                ],
                staticClass: "bookmark__remove",
                attrs: { "aria-label": "Lesezeichen löschen" },
                on: { click: _vm.remove },
              },
              [_vm._v("×")]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }